import { capitalize } from 'lodash';

const SimulationProcessData = (
    pivotData?: any,
    totalTransactions?: number,
    chartType?: RulePerformanceChartType,
    formValues?: ProcessedSimulationReportFormValues,
    deployedData?: SimulationPerformanceTableItem[]
) => {
    let processedData: SimulationPerformanceTableItem[] = [];
    let totalRejectedMatches: number = 0;
    const capitalizedChartType = capitalize(chartType);
    const modifiedRules: Array<string> = formValues?.modifiedRules || [];
    const newRules: Array<string> = formValues?.newRules || [];
    if (pivotData?.length) {
        totalRejectedMatches = pivotData.reduce((acc: any, obj: any) => {
            return acc + Number(obj['SimulationTpp.matchesRejectRules']);
        }, 0);
        const divisor = chartType === 'all' ? Number(totalTransactions) : Number(totalRejectedMatches);
        const topPercentage =
            Number(pivotData[0]['SimulationTpp.matches']) > 0
                ? +Number(pivotData[0]['SimulationTpp.matches']) / divisor
                : 0;

        processedData = pivotData.map((pData: Record<string, any>) => {
            const matches =
                chartType === 'all'
                    ? Number(pData['SimulationTpp.matches'])
                    : Number(pData['SimulationTpp.matchesRejectRules']);
            const matchPercent = matches > 0 ? matches / divisor : 0;
            const isModified = modifiedRules.includes(pData['SimulationTpp.rule']);
            const isNew = newRules.includes(pData['SimulationTpp.rule']);
            return {
                merchantId: pData['SimulationTpp.mid'],
                rule: pData['SimulationTpp.rule'],
                description: pData['SimulationTpp.ruledesc'],
                matches,
                chartType,
                [`percentScaledTriggered${capitalizedChartType}`]:
                    topPercentage !== 0 ? (matchPercent * 100) / topPercentage : 0,
                [`percentTriggered${capitalizedChartType}`]: matchPercent * 100,
                modified: isModified,
                new: isNew,
                performanceData: deployedData?.length
                    ? deployedData.find(({ rule }) => pData['SimulationTpp.rule'] === rule)
                    : {}
            };
        });
    }
    return { processedData, totalRejectedMatches };
};
export default SimulationProcessData;
